"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BENEFICIARY = exports.ACCESSIBLE_BY = exports.MANAGED_BY = void 0;
exports.MANAGED_BY = "managedBy";
exports.ACCESSIBLE_BY = "accessibleBy";
exports.BENEFICIARY = "beneficiary";